import { Injectable } from '@angular/core';
import { Configuration } from '../../../../app/shared/configuration';
import { DataStoreService } from './data-store.service';
import { Country } from '../shared/model/country';
import { CommonUtils } from '../shared/utils/common-utils';
import { FnolService } from './fnol.service';
import { HttpHeaders } from '@angular/common/http';
import { CacheService } from './../../../shared/services/cache.service';

@Injectable({
  providedIn: 'root'
})
export class FnolModelService {

  claimNumberGenerated: string;
  countryData: Country;
  allPartyData: any = [];
  readonly isCountryAuOrNz = CommonUtils.isCountryAuOrNz;
  constructor(private cacheService: CacheService,
    private config: Configuration, private fnolService: FnolService,
    private _dataStoreService: DataStoreService) { }

  setClaimNumber(claimNumber) {
    this.claimNumberGenerated = claimNumber;
    this.cacheService.setClaimNumber(claimNumber);
  }

  generateSetFnolHeader(): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'email-id': this.config.userEmailID,
        'transactionID': this.fnolService.getTransactionId() || '',
      }),
    };
  }

  getClaimNumber(): string {
    return this.claimNumberGenerated ? this.claimNumberGenerated : '';
  }

  clearClaimNumber(): void {
    this.claimNumberGenerated = '';
  }

  getApplicationUserId(): string {
    return this.config.applicationUserId;
  }


}
